var axios = require('axios')
var url = process.env.prefix_campaign_be + '/campaign'
var urlTopic = process.env.prefix_campaign_be + '/topic'
var seoConfigurationUrl = process.env.host + process.env.seo_configuration_url

axios.getCampaignList = function (params, cancel, success, callBackError) {
  this.get(url + '/list?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCampaignDetail = function (params, success, callBackError) {
  this.get(url + '/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createCampaign = function (params, success, callBackError) {
  this.post(url + '/create', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateCampaign = function (params, success, callBackError) {
  this.put(url + '/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadCampaignImages = function (params, configs, success, callBackError) {
  this.post(url + '/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.updateCampaignStatus = function (params, success, callBackError) {
  this.post(url + '/campaign-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

/** ***************************************** topics ***************************************** */

axios.getTopicList = function (params, cancel, success, callBackError) {
  this.get(urlTopic + '/list?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getTopicDetail = function (params, success, callBackError) {
  this.get(urlTopic + '/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createTopic = function (params, success, callBackError) {
  this.post(urlTopic + '/create', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateTopic = function (params, success, callBackError) {
  this.put(urlTopic + '/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadTopicImages = function (params, configs, success, callBackError) {
  this.post(urlTopic + '/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.updateTopicStatus = function (params, success, callBackError) {
  this.post(urlTopic + '/topic-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

/** ***************************************** SEO ***************************************** */

axios.getSEOCampaign = function (params, success, callBackError) {
  this.get(seoConfigurationUrl, { params: params }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.createSEOinfo = function (params, success, callBackError) {
  this.post(seoConfigurationUrl, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateSEOinfo = function (params, success, callBackError) {
  this.put(seoConfigurationUrl, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    })
}

axios.getSEOList = function (clientId, success, callBackError) {
  this.get(seoConfigurationUrl + '?client=' + clientId)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Campaign.js